var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g, _path2, _rect7, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outlook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 20,
    height: 28,
    rx: 2,
    fill: "#1066B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 20,
    height: 28,
    rx: 2,
    fill: "url(#paint0_linear_87_7742)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 10,
    height: 10,
    fill: "#32A9E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 10,
    height: 10,
    fill: "#167EB4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 10,
    height: 10,
    fill: "#32A9E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 10,
    height: 10,
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_7742",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 14,
    width: 24,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H30C31.1046 14 32 14.8954 32 16V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V14Z",
    fill: "url(#paint1_linear_87_7742)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_7742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 14V18H30V14H32Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30V16L7 30H32Z",
    fill: "url(#paint2_linear_87_7742)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 30V16L33 30H8Z",
    fill: "url(#paint3_linear_87_7742)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z",
    fill: "#000000",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint4_linear_87_7742)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.0693V15.903C14 13.0222 11.9272 11 9.01582 11C6.08861 11 4 13.036 4 15.9307V16.097C4 18.9778 6.07278 21 9 21C11.9114 21 14 18.964 14 16.0693ZM11.6424 16.097C11.6424 18.0083 10.5665 19.1579 9.01582 19.1579C7.46519 19.1579 6.37342 17.9806 6.37342 16.0693V15.903C6.37342 13.9917 7.44937 12.8421 9 12.8421C10.5348 12.8421 11.6424 14.0194 11.6424 15.9307V16.097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_7742",
    x1: 10,
    y1: 16,
    x2: 30,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_7742",
    x1: 8,
    y1: 26.7692,
    x2: 32,
    y2: 26.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_7742",
    x1: 32,
    y1: 23,
    x2: 8,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_7742",
    x1: 8,
    y1: 23,
    x2: 32,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_7742",
    x1: 0,
    y1: 16,
    x2: 18,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.882d2bab3aa7d5a7274c7038934f86ae.svg";
export { ForwardRef as ReactComponent };